<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-03-10 10:47:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-14 18:12:03
 * @FilePath: /qd-c4-yunjing-web/src/layouts/components/sidebar/sidebar-collapse-item.vue
 * @Description: 这是默认设置,请设置`customMade`,
-->
<template>
  <!-- 二级菜单由权限或者meta属性中hidden 控制， meta属性属于前期测试使用，后期全部使用权限 -->
  <section v-if=" !item.disabled &&!item.meta?.hidden ">
    <!-- 如果子菜单中有isTabsMenu标识（第4级菜单），则不展开，直接跳转到第一个有权限的子菜单 -->
    <app-link
      v-if="item.children && item.children.length && hasTabsMenuChildren"
      :to="resolvePath(firstAccessibleChild?.path || item.children[0].path)"
      :is-blank="item.isBlank"
    >
      <el-menu-item
        :index="resolvePath(item.path)"
        :class="{'no-drop': !isNest}"
      >
        <template
          #title
        >
          <span>
            {{ item.title }}
          </span>
        </template>
      </el-menu-item>
    </app-link>
    <!-- 普通的子菜单，正常展开 -->
    <el-sub-menu
      v-else-if="item.children&&item.children.length"
      :index="resolvePath(item.path)"
      class="nest-menu"
    >
      <template #title>
        <span>{{ item.title || '' }}</span>
      </template>

      <sidebar-collapse-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :is-nest="true"
        :base-path="resolvePath(child.path)"
        @blank-click="handleToBlank"
      />
    </el-sub-menu>
    <el-menu-item
      v-else-if="item.blank"
      :index="resolvePath(item.path)"
      :class="{'no-drop': !isNest}"
      @click="handleToBlank(item)"
    >
      <template
        #title
      >
        <span>
          {{ item.title }}
        </span>
      </template>
    </el-menu-item>
    <app-link
      v-else
      :to="resolvePath(item.path)"
      :is-blank="item.isBlank"
    >
      <el-menu-item
        :index="resolvePath(item.path)"
        :class="{'no-drop': !isNest}"
      >
        <template
          #title
        >
          <span>
            {{ item.title }}
          </span>
        </template>
      </el-menu-item>
    </app-link>
  </section>
</template>
<script lang="ts">
  import { defineComponent, computed } from 'vue';
  import path from 'path-browserify';
  import { isExternal } from '@/utils/validate';
  import AppLink from './sidebar-link.vue';

  export default defineComponent({
    name: 'sidebar-collapse',
    components: { AppLink },
    props: {
      item: {
        type: Object,
        required: true,
      },
      isNest: {
        type: Boolean,
        default: false,
      },
      basePath: {
        type: String,
        default: '',
      },
    },
    emits: ['blank-click'],
    setup(props, { emit }) {
      /**
       * 检查子菜单是否为第4级tab菜单
       */
      const hasTabsMenuChildren = computed(() => props.item.children?.some((child: any) => child.meta?.isTabsMenu));

      /**
       * 获取第一个有权限的子菜单（非disabled）
       */
      const firstAccessibleChild = computed(() => {
        if (!props.item.children) { return null; }
        return props.item.children.find((child: any) => !child.disabled && !child.meta?.hidden);
      });

      return {
        hasTabsMenuChildren,
        firstAccessibleChild,
        resolvePath: (routePath: any): string => {
          if (isExternal(routePath)) {
            return routePath;
          }
          if (isExternal(props.basePath)) {
            return props.basePath;
          }
          return path.resolve(props.basePath, routePath);
        },
        handleToBlank: (info: TypeObject) => {
          emit('blank-click', info);
        },
      };
    },
  });
</script>
<style lang="scss" scoped>

.nest-main{
  height: 100%;
  background: transparent;
}

</style>
